import React from 'react';
import {
  IonList,
  IonItem,
  IonRadioGroup,
  IonRadio,
  IonLabel,
  IonButton,
  IonText,
} from '@ionic/react';
import Loading from '../../components/spinner';
import Layout from '../../components/layout';
import { withTranslation } from '../../lib/translate';
import { Title, SmallText, Spacer, Sectiontitle } from '../../components/common';
import { connect } from 'react-redux';
import { Capacitor } from '@capacitor/core';
import Basket from '../../lib/basket';
import CheckoutPay from './CheckoutMembershipPay';
import { forwardTo, goBack, isNative, isWebConfig } from '../../lib/utils';
import { payMembership, createSubscription, createSubscriptionNative } from '../../store/subscription/actions';
import { showToast } from '../../store/actions';
import './index.css';

const { getMobile, setMobile } = Basket;

const isWeb = () => Capacitor.getPlatform() === 'web';

class CheckoutMembership extends React.Component {
  constructor(props) {
    super(props);
    if (!getMobile() && this.props.profile && this.props.profile.mobile) {
      setMobile(this.props.profile.mobile);
    }
    this.state = {
      selectedCard: null,
    };
  }

  componentDidMount() {
    const { profile, selectedSubscription } = this.props;

    const { google } = window;
    if (profile.cardToken) {
      this.changeSelectedPaymentCard(profile.cardToken);
    }
    window.googlePayClient = new google.payments.api.PaymentsClient({ environment: 'PRODUCTION' });

    const membership = this.props.subscriptions[selectedSubscription?.idx];
    Basket.setSubscription(membership);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.profile.cardToken !== this.props.profile.cardToken) {
      this.changeSelectedPaymentCard(this.props.profile.cardToken);
    }
  }

  changeSelectedPaymentCard = (cardId) =>
    this.setState({ selectedCard: cardId }, () => {
      Basket.changeSelectedCard(cardId);
    });

  backHandler = () => {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.skipContactDetails
    ) {
      forwardTo('/order-summary', { skipBackToThePreviousPage: true });
    } else if (this.props.location.pathname === '/checkout') {
      forwardTo('/order');
    } else {
      goBack();
    }
  };

  handleClickStripeMembership = (token, cardName) => {
    const subscriptionIdx = this.props.selectedSubscription?.idx;
    if (subscriptionIdx < 0 || subscriptionIdx > this.props.subscriptions) {
      this.props.showToast(this.props.__('Error cannot find membership'));
      return;
    }
    // DO GOOGLE OR APPLE PAY
    this.props.createSubscription({
      id: this.props.selectedSubscription.id,
      token: token.id,
      cardName: cardName,
    });
  };

  handleBuyMembership = () => {
    const subscriptionIdx = this.props.selectedSubscription?.idx;
    if (subscriptionIdx < 0 || subscriptionIdx > this.props.subscriptions) {
      this.props.showToast(this.props.__('Error cannot find membership'));
      return;
    }
    if(isNative()){
      this.props.createSubscriptionNative({
        id: this.props.selectedSubscription.id,
        existingCardToken: this.state.selectedCard,
      });
    }else {
      this.props.createSubscription({
        id: this.props.selectedSubscription.id,
        existingCardToken: this.state.selectedCard,
      });
    }
  };

  render() {
    const { __, cards, location, clientSecret, dispatch } = this.props;

    return (
      <Loading transparent>
        <Layout
          color="transparent"
          headerTitle={__('Checkout Membership')}
          backHandler={this.backHandler}
          hideSecondToolbar={true}
        >
          <div className="flex-row-wrapper absolute-content">
            <Title className='no-margin-bottom'>{__('Choose Payment Card')}</Title>
            <IonText color='primary'>{__('Use saved payment card')}</IonText>
            <IonButton
              
              color="secondary"
              className="link underlined"
              onClick={() => forwardTo('/card-add', { addCardFromMembership: true })}
            >
              {__('Add New Payment Card')}
            </IonButton>
            <Spacer size={2} />
            <div className="scrollable-y">
              <IonList lines="full">
                <IonRadioGroup
                  onIonChange={(e) => this.changeSelectedPaymentCard(e.detail.value)}
                  value={this.state.selectedCard}
                >
                  {cards
                    .reduce((acc, item) => {
                      if (!acc.find((el) => el.fingerprint === item.fingerprint)) {
                        acc.push(item);
                      }
                      return acc;
                    }, [])
                    .map((card) => {
                      const { id, last4, brand, exp_month, exp_year, name } = card;

                      return (
                        <IonItem key={id}>
                          <div tabIndex="-1"></div>
                          <IonRadio
                            slot="start"
                            color={isWebConfig() ? 'secondary' : 'white'}
                            value={id}
                            onIonSelect={() => {
                              this.setState({ selectedCard: id }, () => {
                                Basket.changeSelectedCard(id);
                              });
                            }}
                          />
                          <IonLabel className="ion-text-wrap">
                            <IonText color="primary" className=" bold">
                              {name}
                            </IonText>
                            <Sectiontitle className="no-margin">
                              •••• •••• •••• {last4}
                            </Sectiontitle>
                            <SmallText color="primary">
                              {__(brand)} - {exp_month}/{exp_year}
                            </SmallText>
                          </IonLabel>
                        </IonItem>
                      );
                    })}
                </IonRadioGroup>
              </IonList>
            </div>
            <div className="flex-min">
              {/* Disable stripe for membership */}
              {isWeb() ? (
                <CheckoutPay
                  handleClick={this.handleClickStripeMembership}
                  clientSecret={clientSecret}
                  dispatch={dispatch}
                  __={__}
                  location={location}
                />
              ) : // <DrawPayButton
                //   __={__}
                //   googlePayClient={window.googlePayClient}
                //   isSubscription={true}
                // />
                null}
              <IonButton
                color="secondary"
                disabled={cards.length === 0 || !this.state.selectedCard}
                onClick={this.handleBuyMembership}
                expand="block"
              >
                {__('Confirm Membership')}
              </IonButton>
            </div>
          </div>
        </Layout>
      </Loading>
    );
  }
}

const mapStateToProps = (store) => ({
  cards: store.orders.cards || [],
  profile: store.profile.profile || {},
  clientSecret: store.orders.clientSecret,
  selectedSubscription: store.orders.selectedSubscription,
  subscriptions: store.subscription.subscriptions,
});

const mapDispatchToProps = {
  showToast,
  payMembership,
  createSubscription,
  createSubscriptionNative
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(CheckoutMembership));
